export const styles = theme => ({
  tab: {
    fontFamily: theme.typography.fontKanit,
    opacity: 1,
    fontWeight: 500,
    '&:nth-of-type(even)': {
      borderLeft: '0px solid #ccc',
    },
    border: '1px solid #ccc',
    maxWidth: '-webkit-fill-available',
  },
  active_tab: {
    color: 'white',
    fontFamily: theme.typography.fontKanit,
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 500,
    maxWidth: '-webkit-fill-available',
  },
  container: {
    maxHeight: 506,
  },
  icon: {
    padding: theme.spacing(0),
  },
  powerBy: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 12,
    fontWeight: 300,
  },
  titleSub: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 14,
    fontWeight: 500,
  },
  titleBox: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 19,
    fontWeight: 400,
    background: theme.palette.background.grey,
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(2),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  titleSecondBox: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 16,
    fontWeight: 400,
    background: theme.palette.background.grey,
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(2),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  bodyBox: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.line.main}`,

  },
  bodyTmdBox: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.line.main}`,
    borderRadius: 6,
  }
});